export const SIGNATURE_ACTION = "SIGNATURE_ACTION";

export const DRAFT_SIGNATURE_IMAGE_ACTION = "DRAFT_SIGNATURE_IMAGE_ACTION";

export const GET_FILE_TIMELINE_CRM_ACTION = "GET_FILE_TIMELINE_CRM_ACTION";
export const SET_FILE_TIMELINE_CRM_ACTION = "SET_FILE_TIMELINE_CRM_ACTION";

export const CONFIRM_TIMELINE_CRM_ACTION = "CONFIRM_TIMELINE_CRM_ACTION";
